import React, { useState, useEffect, useRef } from 'react';
import {
    Box, Grid, GridItem, Text, Heading, VStack, HStack, Stack, Button, Switch, FormControl, FormLabel, Input, useToast,
    Divider, Tag, Tabs, TabList, TabPanels, Tab, TabPanel, Link, Icon, SimpleGrid, Textarea, Collapse, Checkbox,
    IconButton, Flex, Tooltip, Alert, AlertIcon, Image, Select, Badge, Spinner, Center,
    Modal, ModalOverlay, ModalContent, ModalCloseButton, ModalBody, useDisclosure,
    AlertDialog, AlertDialogOverlay, AlertDialogContent, AlertDialogHeader, AlertDialogBody, AlertDialogFooter,
} from '@chakra-ui/react';
import { FaExternalLinkAlt, FaExclamationTriangle, FaTimes, FaFileImage, FaCheckCircle, FaUndo, FaTruck, FaThumbsUp, FaThumbsDown, FaRobot, FaIdCard, FaBoxOpen, FaLayerGroup, FaSyncAlt, FaStore, FaSearchPlus, FaExpand, FaTrash, FaMoneyBillWave, FaReceipt, FaCamera } from 'react-icons/fa';
import dayjs from "dayjs";
import "dayjs/locale/pt-br";
import ProdutoImagem from "../ProdutoImagem";
import ReembolsoMercadoPagoModal from "../ReembolsoMercadoPagoModal";
import { getRazoesRevisao, uploadAttachmentRevisao, reuploadAttachmentExistente, removerArquivoDevolucao, sinalizarDivergenciaDevolucao, editarDivergenciaDevolucao, removerDivergenciaDevolucao, getSugestoesLocalizacaoDevolucao, baixarComprovanteReembolsoMp, getNotaDevolucaoPorDevolucao, reprocessarNotaDevolucaoVenda, gerarNotaDevolucaoParaDevolucao } from "../../services/api";
import PainelNotaDevolucao from "../PainelNotaDevolucao";
import MarcacoesNotaDevolucao, { marcacoesIniciais, errosMarcacoes, payloadMarcacoes } from "../MarcacoesNotaDevolucao";
import CorrigirImagemModal from "../despacho/CorrigirImagemModal";
import {
    formatBRL, formatDateTime, formatDate, formatDeadlineShort,
    getStatusDevolucaoLabel, getStatusDevolucaoColor,
    getStatusMoneyLabel, getStatusMoneyColor,
    getTipoDevolucaoLabel,
} from '../../utils/formatters';

const wrapBtn = { whiteSpace: 'normal', h: 'auto', py: 2, lineHeight: 1.3 };
const btnSize = { base: 'md', sm: 'sm' };

const InfoRow = ({ label, value, children }) => (
    <Box>
        <Text fontSize="xs" color="gray.500" fontWeight="medium" textTransform="uppercase" noOfLines={1}>
            {label}
        </Text>
        {children ? children : (
            <Text fontSize="sm" color="gray.800" fontWeight="medium">
                {value || 'N/A'}
            </Text>
        )}
    </Box>
);

const ItemRow = ({ item }) => {
    return (
        <Box p={4} borderWidth="1px" borderRadius="md" bg="gray.50">
            <Flex direction={{ base: "column", md: "row" }} align="start" gap={5}>
                <Box w={{ base: "60px", md: "80px" }} h={{ base: "60px", md: "80px" }} flexShrink={0}>
                    <ProdutoImagem
                        produto={item}
                        origem={null}
                        width={"100%"}
                        height={"100%"}
                    />
                </Box>
                <VStack align="stretch" flex={1}>
                    <Heading size="sm" mb={2}>{item.nome}</Heading>
                    <SimpleGrid columns={{ base: 2, md: 4 }} spacing={3}>
                        <InfoRow label="SKU" value={item.sku} />
                        <InfoRow label="Item ID" value={item.item_id} />
                        <InfoRow label="Qtd. Devolvida" value={item.return_quantity} />
                        <InfoRow label="Qtd. Total" value={item.total_quantity} />
                        <InfoRow label="Preço" value={formatBRL(item.preco)} />
                        <InfoRow label="Preço Total" value={formatBRL(item.preco_total)} />
                        <InfoRow label="Cód. Global" value={item.codigo_global} />
                        <InfoRow label="Cód. Fabricante" value={item.codigo_fabricante} />
                        <InfoRow label="Cód. Fornecedor" value={item.codigo_fornecedor} />
                    </SimpleGrid>
                </VStack>
            </Flex>
        </Box>
    );
};

const STATUS_MANUAIS_MODAL = [
    ['opened', 'Aberta'],
    ['label_generated', 'Etiqueta gerada'],
    ['shipped', 'Enviada'],
    ['delivered', 'Entregue'],
    ['closed', 'Encerrada'],
    ['not_delivered', 'Não entregue'],
    ['cancelled', 'Cancelada'],
    ['failed', 'Falhada'],
    ['expired', 'Expirada'],
];

const KanbanFullDetails = ({ devolucao, onUpdate, onFileUpload, onFileRemoved, isLoading, onIncluirEstoque, onReverterEstoque, onFinalizarManual, onRevisaoOk, onRevisaoFalha, onConsultarCustoEnvio, onSincronizar, onEditarManual, onExcluirManual, onUpdateManualStatus, onAfterDivergenciaChange, onReembolsoConcluido }) => {
    const origem = (devolucao.origem || 'ml').toLowerCase();
    const isManual = origem === 'ecommerce' || origem === 'taga';
    const [isReembolsoMpOpen, setIsReembolsoMpOpen] = useState(false);
    const [files, setFiles] = useState([]);
    const [preAnalise, setPreAnalise] = useState(devolucao.pre_analise || '');
    const [razoes, setRazoes] = useState([]);
    const [showRevisaoFalhaForm, setShowRevisaoFalhaForm] = useState(false);
    const [razaoRevisao, setRazaoRevisao] = useState('');
    const [mensagemRevisao, setMensagemRevisao] = useState('');
    const [attachmentsSelecionados, setAttachmentsSelecionados] = useState([]);
    const [uploadingAttachment, setUploadingAttachment] = useState(false);
    const [previewImagem, setPreviewImagem] = useState(null);
    const [arquivoParaRemover, setArquivoParaRemover] = useState(null);
    const [removendoArquivo, setRemovendoArquivo] = useState(false);
    const cancelRemoveRef = useRef();
    const { isOpen: isPreviewOpen, onOpen: onPreviewOpen, onClose: onPreviewClose } = useDisclosure();

    const abrirPreview = (url, nome) => {
        setPreviewImagem({ url, nome });
        onPreviewOpen();
    };

    const copiarId = async (valor, label) => {
        if (!valor) return;
        try {
            await navigator.clipboard.writeText(String(valor));
            toast({
                title: `${label} copiado`,
                description: String(valor),
                status: 'success',
                duration: 1800,
                isClosable: true,
                position: 'top-right',
            });
        } catch (e) {
            toast({ title: 'Falha ao copiar', status: 'error', duration: 2000 });
        }
    };

    const isImagem = (nome) => nome && /\.(jpe?g|png|gif|webp|bmp|svg)$/i.test(nome);
    const urlArquivo = (path) => `https://adm.tagaautopartes.com.br/${path}`;
    
    // Helpers para verificar status (convertendo para boleano seguro)
    const isEmEstoque = !!(devolucao.estoque === true || devolucao.estoque === 1 || devolucao.estoque === '1');
    const isFinalizadaManual = !!(devolucao.finalizada === true || devolucao.finalizada === 1 || devolucao.finalizada === '1');
    const isAvaria = !!(devolucao.avaria === true || devolucao.avaria === 1 || devolucao.avaria === '1');

    // Se qualquer um dos processos finais ocorreu, considera encerrado para bloquear certas ações (como desmarcar recebido)
    const isProcessoEncerrado = isEmEstoque || isFinalizadaManual || isAvaria;

    // NF-e de devolucao do recebimento (#2225). So existe registro depois que a
    // devolucao foi marcada como recebida, entao o bloco some quando nao ha nada.
    const [notaDevolucao, setNotaDevolucao] = useState(null);
    const [gerandoNota, setGerandoNota] = useState(false);
    const [marcacoesGerar, setMarcacoesGerar] = useState(null);
    const [errosGerarVisiveis, setErrosGerarVisiveis] = useState(false);

    const [showEstoqueForm, setShowEstoqueForm] = useState(false);
    const [sugestoesLoc, setSugestoesLoc] = useState([]);
    const [loadingSugestoes, setLoadingSugestoes] = useState(false);
    const [showFinalizarForm, setShowFinalizarForm] = useState(false);
    const [obsFinalizacao, setObsFinalizacao] = useState('');
    const [showDivergenciaForm, setShowDivergenciaForm] = useState(false);
    const [divergenciaIssues, setDivergenciaIssues] = useState({ photo: false, name: false, code: false, brand: false, avaria: false });
    const [divergenciaObs, setDivergenciaObs] = useState('');
    const [salvandoDivergencia, setSalvandoDivergencia] = useState(false);
    const [divergenciaLocal, setDivergenciaLocal] = useState(devolucao.divergencia || null);
    const [editandoDivergencia, setEditandoDivergencia] = useState(false);
    const [confirmandoRemocaoDiv, setConfirmandoRemocaoDiv] = useState(false);
    const [removendoDivergencia, setRemovendoDivergencia] = useState(false);
    const [corrigirImagemAberto, setCorrigirImagemAberto] = useState(false);

    const usuarioLogado = (() => {
        try { return JSON.parse(window.localStorage.getItem('user')); } catch (e) { return null; }
    })();
    const podeCorrigirImagem = [1, 3].includes(Number(usuarioLogado?.tipo));
    const itemConferido = Array.isArray(devolucao.orders) ? devolucao.orders[0] : null;
    const produtoIdConferido = Number(divergenciaLocal?.produto_id || itemConferido?.sku) || null;
    const produtoCorrecao = produtoIdConferido ? {
        id: produtoIdConferido,
        name: itemConferido?.nome || `Produto #${produtoIdConferido}`,
        globalCode: itemConferido?.codigo_global,
        devolucaoId: devolucao.id,
        observacao: divergenciaObs,
        uniqueId: `devolucao-${devolucao.id}`,
    } : null;
    const correcaoDisponivel = podeCorrigirImagem && !!produtoCorrecao;
    const soFotoMarcada = divergenciaIssues.photo && !divergenciaIssues.name && !divergenciaIssues.code && !divergenciaIssues.brand && !divergenciaIssues.avaria;
    const fotoCorrigida = divergenciaLocal?.foto_corrigida || null;

    const qtdAnexadas = Array.isArray(devolucao.arquivos_anexados) ? devolucao.arquivos_anexados.length : 0;
    const returnQty = devolucao.orders?.reduce((acc, item) => acc + (parseFloat(item.return_quantity) || 0), 0);
    const [qtdEstoque, setQtdEstoque] = useState(devolucao.estoque_qtd ?? devolucao.localizacao?.quantidade ?? returnQty ?? 1);
    const [locEstoque, setLocEstoque] = useState(devolucao.estoque_localizacao ?? devolucao.localizacao?.localizacao ?? '');

    const toast = useToast();
    
    // Helpers de dados seguros para evitar erro de undefined
    const cliente = devolucao.dados_cliente || {};
    const adicional = devolucao.dados_adicionais || {};
    const sellerReview = devolucao.seller_review || {};

    const [baixandoComprovante, setBaixandoComprovante] = useState(false);
    const handleBaixarComprovanteMp = async () => {
        setBaixandoComprovante(true);
        const ok = await baixarComprovanteReembolsoMp(devolucao.id, `comprovante-estorno-${devolucao.id_origem || devolucao.id}.pdf`);
        if (!ok) toast({ title: 'Erro ao baixar o comprovante de estorno.', status: 'error', duration: 6000, isClosable: true });
        setBaixandoComprovante(false);
    };

    useEffect(() => {
        setPreAnalise(devolucao.pre_analise || '');

        setShowEstoqueForm(false);

        setQtdEstoque(devolucao.estoque_qtd ?? devolucao.localizacao?.quantidade ?? returnQty ?? 1);
        setLocEstoque(devolucao.estoque_localizacao ?? devolucao.localizacao?.localizacao ?? '');
        setObsFinalizacao(devolucao.obs_finalizacao || '');

        setDivergenciaLocal(devolucao.divergencia || null);
        setShowDivergenciaForm(false);
        setEditandoDivergencia(false);
        setConfirmandoRemocaoDiv(false);
    }, [devolucao, returnQty]);

    // Recarrega ao trocar de devolução e ao mudar o recebimento: marcar como
    // recebida é o que cria o registro da nota.
    useEffect(() => {
        if (!devolucao?.id) return;
        let cancelado = false;
        getNotaDevolucaoPorDevolucao(devolucao.id).then((res) => {
            if (!cancelado) setNotaDevolucao(res?.existe ? res : null);
        });
        return () => { cancelado = true; };
    }, [devolucao?.id, devolucao?.received]);

    useEffect(() => {
        if (!showEstoqueForm || !devolucao?.id) return;
        let cancelado = false;
        setLoadingSugestoes(true);
        getSugestoesLocalizacaoDevolucao(devolucao.id)
            .then(lista => { if (!cancelado) setSugestoesLoc(lista); })
            .finally(() => { if (!cancelado) setLoadingSugestoes(false); });
        return () => { cancelado = true; };
    }, [showEstoqueForm, devolucao?.id]);

    useEffect(() => {
        let mounted = true;
        getRazoesRevisao(devolucao?.id).then(list => {
            if (mounted && Array.isArray(list)) setRazoes(list);
        });
        return () => { mounted = false; };
    }, [devolucao?.id]);

    const razaoSelecionadaObj = razoes.find(r => r.code === razaoRevisao);
    const requiresAttachments = !!razaoSelecionadaObj?.requires_attachments;

    const handleFileChange = (e) => {
        if (e.target.files) {
            setFiles(prev => [...prev, ...Array.from(e.target.files)]);
        }
        e.target.value = null;
    };
    
    const handleRemoveFile = (fileName) => {
        setFiles(prev => prev.filter(file => file.name !== fileName));
    };

    const handleAnexarESalvar = () => {
        if (files.length === 0 && (!preAnalise || preAnalise.trim() === '')) {
            toast({ title: "Nenhum arquivo ou texto de análise fornecido.", status: "warning", duration: 3000 });
            return;
        }
        onFileUpload(files, preAnalise);
        setFiles([]);
    };

    const handleIncluirEstoqueClick = () => {
        const qtdNum = parseInt(qtdEstoque, 10) || 0;
        const maxQtd = parseInt(returnQty, 10) || 0;
        if (maxQtd > 0 && qtdNum > maxQtd) {
            toast({
                title: "Quantidade inválida",
                description: `A devolução veio com ${maxQtd} unidade(s). Não é possível adicionar mais que isso ao estoque (menos é permitido).`,
                status: "warning",
                duration: 4000,
            });
            return;
        }
        const payload = { qtd: qtdEstoque, loc: locEstoque };
        onIncluirEstoque(payload);
    };
    
    const handleReverterEstoqueClick = () => {
        onReverterEstoque();
    };

    const handleFinalizarClick = () => {
        onFinalizarManual(obsFinalizacao);
    };

    const handleRevisaoOkClick = () => {
        if (typeof onRevisaoOk === 'function') onRevisaoOk();
    };

    const handleAbrirRevisaoFalha = () => {
        setShowRevisaoFalhaForm(prev => !prev);
    };

    const handleEnviarRevisaoFalha = () => {
        if (!razaoRevisao) {
            toast({ title: "Selecione a razão da falha.", status: "warning", duration: 3000 });
            return;
        }
        if (!mensagemRevisao || mensagemRevisao.trim().length < 5) {
            toast({ title: "Descreva o problema (mínimo 5 caracteres).", status: "warning", duration: 3000 });
            return;
        }
        if (requiresAttachments && attachmentsSelecionados.length === 0) {
            toast({
                title: "Evidência obrigatória",
                description: `A razão ${razaoRevisao} exige pelo menos 1 arquivo anexado.`,
                status: "warning",
                duration: 4000,
            });
            return;
        }
        if (typeof onRevisaoFalha === 'function') {
            onRevisaoFalha({
                reason: razaoRevisao,
                message: mensagemRevisao.trim(),
                attachments: attachmentsSelecionados.map(a => a.file_name),
            });
            setRazaoRevisao('');
            setMensagemRevisao('');
            setAttachmentsSelecionados([]);
            setShowRevisaoFalhaForm(false);
        }
    };

    const handleUploadNovoAttachment = async (event) => {
        const file = event.target.files?.[0];
        event.target.value = null;
        if (!file) return;
        setUploadingAttachment(true);
        try {
            const resp = await uploadAttachmentRevisao(devolucao.id, file);
            if (resp?.success && resp.file_name) {
                setAttachmentsSelecionados(prev => [
                    ...prev,
                    { file_name: resp.file_name, label: resp.original_name || file.name, source: 'upload' },
                ]);
                toast({ title: "Arquivo enviado ao ML.", status: "success", duration: 2500 });
            } else {
                toast({
                    title: "Falha no upload",
                    description: resp?.error || 'Erro desconhecido',
                    status: "error",
                    duration: 5000,
                });
            }
        } finally {
            setUploadingAttachment(false);
        }
    };

    const handleReuploadExistente = async (path) => {
        setUploadingAttachment(true);
        try {
            const resp = await reuploadAttachmentExistente(devolucao.id, path);
            if (resp?.success && resp.file_name) {
                setAttachmentsSelecionados(prev => [
                    ...prev,
                    { file_name: resp.file_name, label: path.split('/').pop(), source: 'reupload', origem: path },
                ]);
                toast({ title: "Arquivo enviado ao ML.", status: "success", duration: 2500 });
            } else {
                toast({
                    title: "Falha no re-upload",
                    description: resp?.error || 'Erro desconhecido',
                    status: "error",
                    duration: 5000,
                });
            }
        } finally {
            setUploadingAttachment(false);
        }
    };

    const removerAttachmentSelecionado = (fileName) => {
        setAttachmentsSelecionados(prev => prev.filter(a => a.file_name !== fileName));
    };

    const confirmarRemocaoArquivo = async () => {
        if (!arquivoParaRemover || !devolucao?.id) return;
        setRemovendoArquivo(true);
        try {
            const resp = await removerArquivoDevolucao(devolucao.id, arquivoParaRemover);
            if (resp && resp.success) {
                toast({ title: 'Arquivo removido', status: 'success', duration: 2500 });
                if (typeof onFileRemoved === 'function') onFileRemoved(devolucao.id, arquivoParaRemover);
            } else {
                toast({ title: 'Falha ao remover arquivo', status: 'error', duration: 4000 });
            }
        } catch (e) {
            toast({ title: 'Erro ao remover arquivo', description: e?.message, status: 'error', duration: 4000 });
        } finally {
            setRemovendoArquivo(false);
            setArquivoParaRemover(null);
        }
    };

    const handleConsultarCustoClick = () => {
        if (typeof onConsultarCustoEnvio === 'function') onConsultarCustoEnvio();
    };

    const handleAbrirNovaDivergencia = () => {
        setDivergenciaIssues({ photo: false, name: false, code: false, brand: false, avaria: false });
        setDivergenciaObs('');
        setEditandoDivergencia(false);
        setShowDivergenciaForm(true);
        setConfirmandoRemocaoDiv(false);
    };

    const handleAbrirEdicaoDivergencia = () => {
        if (!divergenciaLocal) return;
        const m = divergenciaLocal.marcacoes || {};
        setDivergenciaIssues({
            photo: !!m.photo,
            name: !!m.name,
            code: !!m.code,
            brand: !!m.brand,
            avaria: !!m.avaria,
        });
        setDivergenciaObs(divergenciaLocal.observacao || '');
        setEditandoDivergencia(true);
        setShowDivergenciaForm(true);
        setConfirmandoRemocaoDiv(false);
    };

    const handleFecharFormDivergencia = () => {
        setShowDivergenciaForm(false);
        setEditandoDivergencia(false);
    };

    const handleSalvarDivergencia = async () => {
        const temMarcacao = Object.values(divergenciaIssues).some(Boolean);
        if (!temMarcacao) {
            toast({ title: 'Selecione ao menos uma marcação', status: 'warning', duration: 3000 });
            return;
        }
        setSalvandoDivergencia(true);
        try {
            const payload = { marcacoes: divergenciaIssues, observacao: divergenciaObs };
            const resp = editandoDivergencia
                ? await editarDivergenciaDevolucao(devolucao.id, payload)
                : await sinalizarDivergenciaDevolucao(devolucao.id, payload);
            if (resp?.success) {
                toast({
                    title: editandoDivergencia ? 'Divergência atualizada' : 'Divergência registrada e produto bloqueado',
                    status: 'success',
                    duration: 3000,
                });
                const novaDiv = resp.divergencia || null;
                setDivergenciaLocal(novaDiv);
                try { devolucao.divergencia = novaDiv; } catch (e) { }
                setShowDivergenciaForm(false);
                setEditandoDivergencia(false);
                if (typeof onAfterDivergenciaChange === 'function') onAfterDivergenciaChange(devolucao.id);
            } else {
                toast({ title: resp?.error || 'Erro ao salvar divergência', status: 'error', duration: 5000, isClosable: true });
            }
        } finally {
            setSalvandoDivergencia(false);
        }
    };

    const handleConfirmarRemocaoDivergencia = async () => {
        setRemovendoDivergencia(true);
        try {
            const resp = await removerDivergenciaDevolucao(devolucao.id);
            if (resp?.success) {
                toast({ title: 'Divergência removida', status: 'success', duration: 3000 });
                setDivergenciaLocal(null);
                try { devolucao.divergencia = null; } catch (e) { }
                setConfirmandoRemocaoDiv(false);
                if (typeof onAfterDivergenciaChange === 'function') onAfterDivergenciaChange(devolucao.id);
            } else {
                toast({ title: resp?.error || 'Erro ao remover divergência', status: 'error', duration: 5000, isClosable: true });
            }
        } finally {
            setRemovendoDivergencia(false);
        }
    };

    const handleImagemCorrigida = (_produto, res) => {
        if (res?.divergencia) {
            setDivergenciaLocal(res.divergencia);
            try { devolucao.divergencia = res.divergencia; } catch (e) { }
        }
        setShowDivergenciaForm(false);
        setEditandoDivergencia(false);
        setConfirmandoRemocaoDiv(false);
        if (typeof onAfterDivergenciaChange === 'function') onAfterDivergenciaChange(devolucao.id);
    };

    const urgency = devolucao.urgency_level || 'sem_prazo';
    const deadlineWhen = formatDeadlineShort(devolucao.review_due_date_util, '');
    const deadlineLabel = urgency === 'urgente'
        ? 'Revisar HOJE'
        : urgency === 'atrasada'
            ? `Atrasada${deadlineWhen ? ` (${deadlineWhen})` : ''}`
            : deadlineWhen
                ? `Revisar até ${deadlineWhen}`
                : (adicional.title || 'Ação Necessária');

    const reviewResult = devolucao.review_result;
    const reviewBadge = {
        ok: { label: 'Revisão: CHEGOU OK', color: 'green' },
        failed: { label: 'Revisão: COM FALHA', color: 'red' },
        pending: { label: 'Revisão: PENDENTE', color: 'yellow' },
    }[reviewResult] || null;
    const jaRevisada = reviewResult === 'ok' || reviewResult === 'failed'
        || devolucao.reviewed === 1 || devolucao.reviewed === true;

    const shippingPaidBy = (devolucao.shipping_paid_by || '').toString().toLowerCase();
    const shippingCostValor = devolucao.shipping_cost;
    const pagoPor = {
        seller:       { label: 'Pago por NÓS (Vendedor)',  color: 'red',    status: 'warning', detalhe: 'O custo do envio de devolução será descontado da nossa conta no Mercado Livre.' },
        buyer:        { label: 'Pago pelo COMPRADOR',      color: 'green',  status: 'success', detalhe: 'O comprador é o responsável pelo custo do envio.' },
        mercadolibre: { label: 'Pago pelo MERCADO LIVRE',  color: 'blue',   status: 'info',    detalhe: 'O Mercado Livre está subsidiando o custo do envio.' },
        meli:         { label: 'Pago pelo MERCADO LIVRE',  color: 'blue',   status: 'info',    detalhe: 'O Mercado Livre está subsidiando o custo do envio.' },
    }[shippingPaidBy] || (shippingPaidBy ? { label: `Pago por: ${shippingPaidBy}`, color: 'gray', status: 'info', detalhe: null } : null);

    const formatAddress = (c) => {
        if (!c.street_name) return 'Endereço não informado';
        return `${c.street_name}, ${c.street_number || 'S/N'}, ${c.neighborhood}, ${c.city_name} - ${c.state_code}, CEP: ${c.zip_code}`;
    };
    
    const getSituacaoProduto = () => {
        if (isAvaria) return <Tag colorScheme="red">AVARIA</Tag>;
        if (isEmEstoque) return <Tag colorScheme="green">EM ESTOQUE</Tag>;
        if (isFinalizadaManual) return <Tag colorScheme="gray">FINALIZADA</Tag>;
        return <Tag colorScheme="blue">SEM DEFEITO</Tag>;
    };

    const podeExcluirManual = isManual && !isEmEstoque && !isAvaria && !isFinalizadaManual;

    return (
        <VStack spacing={4} align="stretch">
            <Flex justify="space-between" align="center" wrap="wrap" gap={2}>
                <HStack>
                    {isManual && (
                        <Badge colorScheme="purple" fontSize="11px" px={2} py={1} borderRadius="md">
                            Devolução manual — {origem.toUpperCase()}
                        </Badge>
                    )}
                </HStack>
                <HStack>
                    {isManual && (
                        <>
                            {origem === 'ecommerce' && (
                                adicional?.reembolso_mp ? (
                                    <Tooltip label={`Estorno de R$ ${Number(adicional.reembolso_mp.valor).toFixed(2).replace('.', ',')} feito em ${adicional.reembolso_mp.data} por ${adicional.reembolso_mp.user_name}. Baixa o comprovante em PDF para enviar ao cliente.`} hasArrow>
                                        <Button size={btnSize} variant="outline" colorScheme="green" leftIcon={<FaReceipt />} onClick={handleBaixarComprovanteMp} isLoading={baixandoComprovante} isDisabled={isLoading} {...wrapBtn}>
                                            Comprovante do estorno
                                        </Button>
                                    </Tooltip>
                                ) : (
                                    <Button size={btnSize} variant="outline" colorScheme="green" leftIcon={<FaMoneyBillWave />} onClick={() => setIsReembolsoMpOpen(true)} isDisabled={isLoading} {...wrapBtn}>
                                        Devolver dinheiro (MP)
                                    </Button>
                                )
                            )}
                            <Button size={btnSize} variant="outline" colorScheme="blue" onClick={() => onEditarManual && onEditarManual()} isDisabled={isLoading} {...wrapBtn}>
                                Editar manual
                            </Button>
                            {podeExcluirManual && (
                                <Button size={btnSize} variant="outline" colorScheme="red" onClick={() => onExcluirManual && onExcluirManual()} isDisabled={isLoading} {...wrapBtn}>
                                    Excluir
                                </Button>
                            )}
                        </>
                    )}
                    {!isManual && (
                        <Tooltip label="Consulta o Mercado Livre agora e atualiza todos os dados desta devolução (status, revisão, valores, custo de envio, etc)." hasArrow placement="left">
                            <Button
                                size={btnSize}
                                colorScheme="orange"
                                variant="outline"
                                leftIcon={<FaSyncAlt />}
                                onClick={() => typeof onSincronizar === 'function' && onSincronizar()}
                                isDisabled={isLoading}
                                isLoading={isLoading}
                                {...wrapBtn}
                            >
                                Sincronizar com ML
                            </Button>
                        </Tooltip>
                    )}
                </HStack>
            </Flex>

            <Box bg="gray.50" p={4} borderRadius="lg" borderWidth="1px" borderColor="gray.200">
                <Grid templateColumns={{ base: "1fr", md: "1fr 1fr" }} gap={{ base: 4, md: 6 }}>
                    
                    {/* Coluna Esquerda: Status e Controle Principal */}
                    <VStack align="stretch" justify="center" spacing={3}>
                        <HStack>
                            <Icon as={FaExclamationTriangle} color="orange.500" w={5} h={5} />
                            <Heading size="sm" color="orange.700">{deadlineLabel}</Heading>
                        </HStack>
                        <Text fontSize="sm" color="gray.600" mt={2}>{adicional.description || 'Revise o status da devolução.'}</Text>
                        
                        <FormControl display="flex" alignItems="center" justifyContent="space-between" gap={3} p={3} bg="white" borderRadius="md" boxShadow="sm">
                            <FormLabel htmlFor="received-switch" mb="0" fontWeight="bold" fontSize={{ base: 'sm', md: 'md' }} flex="1" minW={0}>
                                Produto Recebido?
                            </FormLabel>
                            <Switch
                                id="received-switch"
                                colorScheme="orange"
                                size="lg"
                                flexShrink={0}
                                isChecked={devolucao.received}
                                onChange={() => onUpdate('received', !devolucao.received)}
                                isDisabled={isLoading || isProcessoEncerrado}
                            />
                        </FormControl>

                        {isManual && (
                            <FormControl display="flex" alignItems="center" justifyContent="space-between" gap={3} p={3} bg="white" borderRadius="md" boxShadow="sm">
                                <FormLabel htmlFor="status-manual-select" mb="0" fontWeight="bold" fontSize={{ base: 'sm', md: 'md' }} flex="1" minW={0}>
                                    Status
                                </FormLabel>
                                <Select
                                    id="status-manual-select"
                                    size="sm"
                                    maxW="180px"
                                    flexShrink={0}
                                    value={devolucao.status || 'opened'}
                                    onChange={(e) => onUpdateManualStatus && onUpdateManualStatus(e.target.value)}
                                    isDisabled={isLoading}
                                >
                                    {STATUS_MANUAIS_MODAL.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
                                </Select>
                            </FormControl>
                        )}
                    </VStack>
                    
                    {/* Coluna Direita: Ações de Estoque/Avaria/Finalização */}
                    <VStack align="stretch" spacing={3}>
                            
                        {/* ALERTA E REVERSÃO DE FINALIZAÇÃO MANUAL (Apenas se finalizada manual e NÃO está em estoque) */}
                        {isFinalizadaManual && !isEmEstoque && (
                            <Box>
                                <Alert status="success" borderRadius="md" variant="subtle" mb={2}>
                                    <AlertIcon />
                                    <Box>
                                        <Text fontWeight="bold" fontSize="sm">Devolução Finalizada Manualmente</Text>
                                        <Text fontSize="xs">{devolucao.obs_finalizacao || 'Sem observações.'}</Text>
                                    </Box>
                                </Alert>
                                <Button
                                    colorScheme="red"
                                    variant="outline"
                                    w="100%"
                                    size={btnSize}
                                    leftIcon={<FaUndo />}
                                    onClick={handleReverterEstoqueClick}
                                    isLoading={isLoading}
                                    {...wrapBtn}
                                >
                                    Reverter Finalização (Voltar)
                                </Button>
                            </Box>
                        )}

                        {/* BLOCO DE AÇÕES PRINCIPAIS (Avaria / Estoque) */}
                        <Collapse in={devolucao.received || isProcessoEncerrado} animateOpacity>
                            <VStack align="stretch" spacing={3}>
                                <HStack justify="space-between">
                                    <Text fontSize="sm" fontWeight="bold">Situação:</Text>
                                    {getSituacaoProduto()}
                                </HStack>

                                {!isProcessoEncerrado && !isFinalizadaManual && (
                                    <Box
                                        borderWidth="2px"
                                        borderColor={qtdAnexadas > 0 ? "green.300" : "orange.300"}
                                        bg={qtdAnexadas > 0 ? "green.50" : "orange.50"}
                                        borderRadius="md"
                                        p={3}
                                    >
                                        <HStack justify="space-between" mb={2} flexWrap="wrap">
                                            <HStack spacing={2}>
                                                <Icon as={FaFileImage} color={qtdAnexadas > 0 ? "green.500" : "orange.500"} />
                                                <Text fontSize="sm" fontWeight="bold" color={qtdAnexadas > 0 ? "green.700" : "orange.700"}>
                                                    Fotos da Conferência {qtdAnexadas > 0 ? `(${qtdAnexadas} anexada${qtdAnexadas > 1 ? 's' : ''})` : '— obrigatórias'}
                                                </Text>
                                            </HStack>
                                            {qtdAnexadas === 0 && (
                                                <Badge colorScheme="orange" fontSize="10px">PENDENTE</Badge>
                                            )}
                                        </HStack>

                                        {qtdAnexadas > 0 && (
                                            <SimpleGrid columns={{ base: 4, md: 6 }} spacing={2} mb={2}>
                                                {devolucao.arquivos_anexados.slice(0, 6).map((arqString, idx) => {
                                                    const filename = arqString.split('/').pop();
                                                    const isImg = filename && /\.(jpe?g|png|gif|webp)$/i.test(filename);
                                                    const url = `https://adm.tagaautopartes.com.br/${arqString}`;
                                                    return (
                                                        <Box
                                                            key={idx}
                                                            borderWidth="1px"
                                                            borderColor="gray.200"
                                                            borderRadius="md"
                                                            overflow="hidden"
                                                            cursor={isImg ? 'pointer' : 'default'}
                                                            onClick={() => isImg && abrirPreview(url, filename)}
                                                            position="relative"
                                                            h="60px"
                                                        >
                                                            {isImg ? (
                                                                <Image src={url} alt={filename} objectFit="cover" w="100%" h="100%" />
                                                            ) : (
                                                                <Center h="100%"><Icon as={FaFileImage} color="gray.400" /></Center>
                                                            )}
                                                        </Box>
                                                    );
                                                })}
                                            </SimpleGrid>
                                        )}

                                        <Input
                                            type="file"
                                            multiple
                                            id="conferencia-fotos-input"
                                            display="none"
                                            onChange={handleFileChange}
                                            isDisabled={isLoading}
                                        />
                                        <Stack direction={{ base: 'column', sm: 'row' }} spacing={2}>
                                            <Button
                                                as="label"
                                                htmlFor="conferencia-fotos-input"
                                                size={btnSize}
                                                colorScheme={qtdAnexadas > 0 ? "green" : "orange"}
                                                variant="outline"
                                                leftIcon={<FaFileImage />}
                                                isDisabled={isLoading}
                                                w="100%"
                                                {...wrapBtn}
                                            >
                                                {qtdAnexadas > 0 ? 'Anexar mais fotos' : 'Selecionar fotos...'}
                                            </Button>
                                            {files.length > 0 && (
                                                <Button
                                                    size={btnSize}
                                                    colorScheme="blue"
                                                    onClick={handleAnexarESalvar}
                                                    isLoading={isLoading}
                                                    w="100%"
                                                    {...wrapBtn}
                                                >
                                                    Salvar {files.length} arquivo{files.length > 1 ? 's' : ''}
                                                </Button>
                                            )}
                                        </Stack>

                                        {files.length > 0 && (
                                            <VStack align="stretch" spacing={1} mt={2} maxH="100px" overflowY="auto">
                                                {files.map((file, idx) => (
                                                    <HStack key={idx} justify="space-between" p={1} bg="white" borderRadius="sm" fontSize="xs">
                                                        <HStack spacing={1} overflow="hidden">
                                                            <Icon as={FaFileImage} color="gray.500" boxSize={3} />
                                                            <Text isTruncated>{file.name}</Text>
                                                        </HStack>
                                                        <IconButton
                                                            icon={<FaTimes />}
                                                            size="xs"
                                                            variant="ghost"
                                                            colorScheme="red"
                                                            onClick={() => handleRemoveFile(file.name)}
                                                            isDisabled={isLoading}
                                                        />
                                                    </HStack>
                                                ))}
                                            </VStack>
                                        )}
                                    </Box>
                                )}

                                {!isFinalizadaManual && (
                                    <>
                                        {qtdAnexadas === 0 && !isProcessoEncerrado && (
                                            <Alert status="warning" borderRadius="md" py={2} fontSize="xs">
                                                <AlertIcon boxSize={3} />
                                                Anexe ao menos 1 foto da conferência antes de marcar avaria.
                                            </Alert>
                                        )}
                                        <Stack direction={{ base: 'column', md: 'row' }} spacing={2} w="100%">
                                            <Button
                                                colorScheme="red"
                                                w="100%"
                                                size={btnSize}
                                                variant={isAvaria ? "solid" : "outline"}
                                                onClick={() => onUpdate('avaria', 1)}
                                                isDisabled={isLoading || isEmEstoque || (qtdAnexadas === 0 && !isProcessoEncerrado)}
                                                {...wrapBtn}
                                            >
                                                Marcar COM Avaria
                                            </Button>
                                            <Button
                                                colorScheme="green"
                                                w="100%"
                                                size={btnSize}
                                                variant={!isAvaria && !isEmEstoque ? "solid" : "outline"}
                                                onClick={() => onUpdate('avaria', 0)}
                                                isDisabled={isLoading || isEmEstoque || (qtdAnexadas === 0 && !isProcessoEncerrado)}
                                                {...wrapBtn}
                                            >
                                                Marcar SEM Avaria
                                            </Button>
                                        </Stack>
                                    </>
                                )}
                                
                                {/* Controle de Estoque: Exibe se NÃO for Avaria, e (NÃO Finalizada Manualmente OU Já estiver no Estoque) */}
                                {!isAvaria && (!isFinalizadaManual || isEmEstoque) && (qtdAnexadas > 0 || isEmEstoque) && (
                                    <Box>
                                        {isEmEstoque && !showEstoqueForm ? (
                                            <Box bg="green.50" borderWidth="1px" borderColor="green.300" borderRadius="md" p={3}>
                                                <HStack justify="space-between" align="center" flexWrap="wrap" gap={2}>
                                                    <HStack spacing={2} align="center">
                                                        <Icon as={FaCheckCircle} color="green.500" />
                                                        <VStack align="start" spacing={0}>
                                                            <Text fontSize="sm" fontWeight="bold" color="green.700">
                                                                Item em estoque
                                                            </Text>
                                                            <Text fontSize="xs" color="gray.700">
                                                                Qtd: <strong>{devolucao.estoque_qtd ?? qtdEstoque}</strong> &nbsp;|&nbsp; Local: <strong>{devolucao.estoque_localizacao ?? locEstoque}</strong>
                                                            </Text>
                                                        </VStack>
                                                    </HStack>
                                                    <Button
                                                        size={btnSize}
                                                        colorScheme="green"
                                                        variant="outline"
                                                        onClick={() => setShowEstoqueForm(true)}
                                                        isDisabled={isLoading}
                                                    >
                                                        Editar Localização/Qtd
                                                    </Button>
                                                </HStack>
                                            </Box>
                                        ) : (
                                            <Button
                                                colorScheme="green"
                                                w="100%"
                                                onClick={() => setShowEstoqueForm(prev => !prev)}
                                                variant={showEstoqueForm ? "outline" : "solid"}
                                                isDisabled={isLoading}
                                                {...wrapBtn}
                                            >
                                                {isEmEstoque ? "Fechar edição" : (showEstoqueForm ? "Cancelar" : "Incluir no Estoque")}
                                            </Button>
                                        )}

                                        <Collapse in={showEstoqueForm} animateOpacity>
                                            <VStack p={4} bg="white" borderRadius="md" boxShadow="sm" spacing={3} mt={2} borderWidth="1px" borderColor="gray.200">
                                                <FormControl>
                                                    <FormLabel fontSize="sm">Quantidade</FormLabel>
                                                    <Input
                                                        type="number"
                                                        value={qtdEstoque}
                                                        onChange={(e) => {
                                                            const raw = e.target.value;
                                                            if (raw === '') { setQtdEstoque(''); return; }
                                                            const n = parseInt(raw, 10);
                                                            if (isNaN(n)) return;
                                                            const max = parseInt(returnQty, 10) || 0;
                                                            if (max > 0 && n > max) {
                                                                setQtdEstoque(max);
                                                                return;
                                                            }
                                                            setQtdEstoque(n < 0 ? 0 : n);
                                                        }}
                                                        isDisabled={isLoading}
                                                        min={1}
                                                        max={returnQty || undefined}
                                                    />
                                                    {returnQty > 0 && (
                                                        <Text fontSize="xs" color="gray.500" mt={1}>
                                                            Máx: {returnQty} (qtd da devolução).
                                                        </Text>
                                                    )}
                                                </FormControl>
                                                <FormControl>
                                                    <FormLabel fontSize="sm">Localização</FormLabel>
                                                    <Input
                                                        placeholder="Ex: A-01-B"
                                                        value={locEstoque}
                                                        onChange={(e) => setLocEstoque(e.target.value)}
                                                        isDisabled={isLoading}
                                                    />
                                                </FormControl>
                                                {(loadingSugestoes || sugestoesLoc.length > 0) && (
                                                    <Box w="100%" bg="blue.50" borderWidth="1px" borderColor="blue.200" borderRadius="md" p={3}>
                                                        <HStack spacing={2} mb={2}>
                                                            <Icon as={FaBoxOpen} color="blue.500" />
                                                            <Text fontSize="xs" fontWeight="semibold" color="blue.700">
                                                                Unidades deste produto já em estoque
                                                            </Text>
                                                        </HStack>
                                                        {loadingSugestoes ? (
                                                            <HStack><Spinner size="xs" /><Text fontSize="xs" color="gray.600">Carregando...</Text></HStack>
                                                        ) : (
                                                            <Flex wrap="wrap" gap={2}>
                                                                {sugestoesLoc.map((s, i) => {
                                                                    const isAtual = locEstoque && s.localizacao && locEstoque.trim().toLowerCase() === s.localizacao.trim().toLowerCase();
                                                                    return (
                                                                        <Button
                                                                            key={i}
                                                                            size="xs"
                                                                            colorScheme={isAtual ? "green" : "blue"}
                                                                            variant={isAtual ? "solid" : "outline"}
                                                                            onClick={() => setLocEstoque(s.localizacao)}
                                                                            isDisabled={isLoading}
                                                                        >
                                                                            {s.localizacao} ({s.quantidade} un){isAtual ? " ✓" : ""}
                                                                        </Button>
                                                                    );
                                                                })}
                                                            </Flex>
                                                        )}
                                                        <Text fontSize="xs" color="gray.500" mt={2}>
                                                            Clique para alocar nesta mesma localização.
                                                        </Text>
                                                    </Box>
                                                )}
                                                <Button
                                                    w="100%"
                                                    colorScheme="green"
                                                    onClick={handleIncluirEstoqueClick}
                                                    isDisabled={!qtdEstoque || !locEstoque || isLoading}
                                                    isLoading={isLoading}
                                                    {...wrapBtn}
                                                >
                                                    {isEmEstoque ? "Atualizar Estoque" : "Confirmar Inclusão"}
                                                </Button>
                                                {isEmEstoque && (
                                                    <Button
                                                        w="100%"
                                                        colorScheme="red"
                                                        variant="outline"
                                                        size={btnSize}
                                                        onClick={handleReverterEstoqueClick}
                                                        isDisabled={isLoading}
                                                        isLoading={isLoading}
                                                        {...wrapBtn}
                                                    >
                                                        Reverter (Remover do Estoque)
                                                    </Button>
                                                )}
                                            </VStack>
                                        </Collapse>
                                    </Box>
                                )}
                            </VStack>
                        </Collapse>

                        {/* Botão Finalizar Manualmente - Aparece se o processo NÃO estiver encerrado (Nem estoque, nem avaria, nem finalizada) */}
                        {!isEmEstoque && !isAvaria && !isFinalizadaManual && (
                            <Box mt={2}>
                                <Button
                                    colorScheme="gray"
                                    leftIcon={<FaCheckCircle />}
                                    w="100%"
                                    size={btnSize}
                                    variant={showFinalizarForm ? "outline" : "ghost"}
                                    onClick={() => setShowFinalizarForm(prev => !prev)}
                                    isDisabled={isLoading}
                                    {...wrapBtn}
                                >
                                    Outras Finalizações (Não Recebido/Estorno)
                                </Button>

                                <Collapse in={showFinalizarForm} animateOpacity>
                                    <VStack p={3} bg="gray.100" borderRadius="md" spacing={3} mt={2} border="1px dashed" borderColor="gray.400">
                                        <Text fontSize="xs" color="gray.600" textAlign="center">
                                            Use para finalizar devoluções que <b>não entrarão no estoque</b> (ex: extravio, comprador não enviou, etc).
                                        </Text>
                                        <Textarea 
                                            placeholder="Digite o motivo da finalização..."
                                            value={obsFinalizacao}
                                            onChange={(e) => setObsFinalizacao(e.target.value)}
                                            bg="white"
                                            size="sm"
                                        />
                                        <Button
                                            colorScheme="blue"
                                            w="100%"
                                            size={btnSize}
                                            onClick={handleFinalizarClick}
                                            isLoading={isLoading}
                                            {...wrapBtn}
                                        >
                                            Confirmar Finalização
                                        </Button>
                                    </VStack>
                                </Collapse>
                            </Box>
                        )}
                    </VStack>
                </Grid>
            </Box>

            {/* Devolucao recebida ANTES desta funcionalidade existir nao tem registro.
                O botao faz o mesmo caminho do recebimento sem mexer no kanban. */}
            {!notaDevolucao?.registro && devolucao.received && (
                <Box bg="white" borderWidth="1px" borderRadius="lg" p={4}>
                    <Flex justify="space-between" align="center" gap={3} wrap="wrap">
                        <Box>
                            <Text fontSize="sm" fontWeight="semibold">Nota fiscal de devolução</Text>
                            <Text fontSize="xs" color="gray.500" mt={1}>
                                Esta devolução não tem nota gerada. Recebimentos anteriores à
                                automação precisam ser disparados manualmente.
                            </Text>
                        </Box>
                        <Button
                            size="sm"
                            colorScheme="orange"
                            variant="outline"
                            leftIcon={<FaReceipt />}
                            isLoading={gerandoNota}
                            {...wrapBtn}
                            onClick={() => {
                                setErrosGerarVisiveis(false);
                                setMarcacoesGerar(marcacoesIniciais({}, devolucao.recebida_at || devolucao.received_at || null));
                            }}
                        >
                            Gerar nota de devolução
                        </Button>
                    </Flex>
                </Box>
            )}

            <Modal isOpen={!!marcacoesGerar} onClose={() => setMarcacoesGerar(null)} size={{ base: 'full', sm: 'lg' }}>
                <ModalOverlay />
                <ModalContent>
                    <ModalCloseButton />
                    <ModalBody pt={10} pb={4}>
                        <Text fontSize="sm" fontWeight="semibold" mb={3}>Nota fiscal de devolução</Text>
                        {marcacoesGerar && (
                            <MarcacoesNotaDevolucao
                                valores={marcacoesGerar}
                                onChange={setMarcacoesGerar}
                                erros={errosMarcacoes(marcacoesGerar)}
                                mostrarErros={errosGerarVisiveis}
                            />
                        )}
                        <Flex justify="flex-end" gap={2} mt={5} direction={{ base: 'column-reverse', sm: 'row' }}>
                            <Button size="sm" variant="ghost" onClick={() => setMarcacoesGerar(null)}>Cancelar</Button>
                            <Button
                                size="sm"
                                colorScheme="orange"
                                isLoading={gerandoNota}
                                onClick={async () => {
                                    if (Object.keys(errosMarcacoes(marcacoesGerar)).length) {
                                        setErrosGerarVisiveis(true);
                                        return;
                                    }
                                    setGerandoNota(true);
                                    const res = await gerarNotaDevolucaoParaDevolucao(devolucao.id, payloadMarcacoes(marcacoesGerar));
                                    setGerandoNota(false);
                                    if (res?.error) {
                                        toast({ title: 'Não foi possível gerar', description: res.error, status: 'error', duration: 6000, isClosable: true });
                                        return;
                                    }
                                    toast({
                                        title: 'Nota enfileirada',
                                        description: `Emissão disparada em ${res?.ambiente === 'producao' ? 'PRODUÇÃO' : 'homologação'}. Acompanhe aqui ou em Notas de Devolução.`,
                                        status: 'success',
                                        duration: 6000,
                                        isClosable: true,
                                    });
                                    setMarcacoesGerar(null);
                                    setNotaDevolucao(res);
                                }}
                            >
                                Gerar nota
                            </Button>
                        </Flex>
                    </ModalBody>
                </ModalContent>
            </Modal>

            {notaDevolucao?.registro && (
                <PainelNotaDevolucao
                    dados={notaDevolucao}
                    compacto
                    toast={toast}
                    onAtualizado={(novo) => setNotaDevolucao(novo)}
                    onReprocessar={async () => {
                        const res = await reprocessarNotaDevolucaoVenda(notaDevolucao.registro.id);
                        if (res?.error) {
                            toast({ title: 'Erro', description: res.error, status: 'error', duration: 5000, isClosable: true });
                        } else {
                            toast({ title: 'Reenfileirada', status: 'success', duration: 3000, isClosable: true });
                            setNotaDevolucao(res);
                        }
                    }}
                />
            )}

            <Box bg="red.50" borderRadius="lg" borderWidth="1px" borderColor="red.200" overflow="hidden">
                <Flex
                    px={4} py={3}
                    justify="space-between"
                    align="center"
                    cursor={!divergenciaLocal ? "pointer" : "default"}
                    onClick={!divergenciaLocal ? () => setShowDivergenciaForm(prev => !prev) : undefined}
                    _hover={!divergenciaLocal ? { bg: 'red.100' } : undefined}
                    transition="background 0.15s"
                >
                    <HStack spacing={2}>
                        <Icon as={FaExclamationTriangle} color="red.500" />
                        <Heading size="sm" color="red.700">
                            {divergenciaLocal ? 'Divergência Registrada' : 'Sinalizar Divergência'}
                        </Heading>
                    </HStack>
                    {!divergenciaLocal && (
                        <Button
                            size="xs"
                            colorScheme="red"
                            variant={showDivergenciaForm ? "solid" : "outline"}
                            onClick={(e) => { e.stopPropagation(); setShowDivergenciaForm(prev => !prev); }}
                            tabIndex={-1}
                        >
                            {showDivergenciaForm ? 'Fechar' : 'Abrir'}
                        </Button>
                    )}
                </Flex>

                {divergenciaLocal && !showDivergenciaForm && (
                    <Box px={4} pb={4}>
                        <Box bg="white" p={3} borderRadius="md" borderWidth="1px" borderColor="red.200">
                            <HStack spacing={2} flexWrap="wrap" mb={divergenciaLocal.observacao ? 3 : 2}>
                                {[
                                    { key: 'photo', label: 'Foto divergente' },
                                    { key: 'name', label: 'Nome divergente' },
                                    { key: 'code', label: 'Código divergente' },
                                    { key: 'brand', label: 'Marca divergente' },
                                    { key: 'avaria', label: 'Avaria / Dano' },
                                ].filter(it => divergenciaLocal.marcacoes?.[it.key]).map(it => (
                                    <Tag key={it.key} colorScheme="red" size="sm" borderRadius="md">{it.label}</Tag>
                                ))}
                                {fotoCorrigida && (
                                    <Tag colorScheme="green" size="sm" borderRadius="md">
                                        <Icon as={FaCheckCircle} boxSize={3} mr={1} />
                                        Foto corrigida
                                    </Tag>
                                )}
                            </HStack>

                            {divergenciaLocal.observacao && (
                                <Box mb={2}>
                                    <Text fontSize="10px" color="gray.500" textTransform="uppercase" fontWeight="semibold">Observação</Text>
                                    <Text fontSize="sm" whiteSpace="pre-wrap" color="gray.800">{divergenciaLocal.observacao}</Text>
                                </Box>
                            )}

                            <Text fontSize="11px" color="gray.500" mt={2}>
                                Registrado por <b>{divergenciaLocal.created_by_name || 'Sistema'}</b>
                                {divergenciaLocal.created_at ? ` em ${divergenciaLocal.created_at}` : ''}
                                {divergenciaLocal.updated_at && divergenciaLocal.updated_at !== divergenciaLocal.created_at && (
                                    <> · Atualizado {divergenciaLocal.updated_by_name ? `por ${divergenciaLocal.updated_by_name} ` : ''}em {divergenciaLocal.updated_at}</>
                                )}
                            </Text>

                            {fotoCorrigida && (
                                <HStack mt={3} p={3} spacing={2} align="start" bg="green.50" borderRadius="md" borderWidth="1px" borderColor="green.200">
                                    <Icon as={FaCheckCircle} color="green.500" mt="2px" flexShrink={0} />
                                    <Box minW={0}>
                                        <Text fontSize="sm" fontWeight="semibold" color="green.800">Imagem oficial corrigida</Text>
                                        <Text fontSize="xs" color="green.700" wordBreak="break-word">
                                            {fotoCorrigida.fotos ? `${fotoCorrigida.fotos} foto(s) do item físico publicadas` : 'Fotos do item físico publicadas'}
                                            {fotoCorrigida.por_nome ? ` por ${fotoCorrigida.por_nome}` : ''}
                                            {fotoCorrigida.em ? ` em ${formatDateTime(fotoCorrigida.em)}` : ''}.
                                        </Text>
                                        <Text fontSize="xs" color={divergenciaLocal.produto_bloqueado ? 'orange.700' : 'green.700'} mt={1}>
                                            {fotoCorrigida.desbloqueou
                                                ? 'Produto desbloqueado nesta correção.'
                                                : (divergenciaLocal.produto_bloqueado ? 'O produto continua bloqueado.' : 'Produto liberado para venda.')}
                                            {fotoCorrigida.ticket_fechado ? ` Ticket #${fotoCorrigida.ticket_fechado} fechado.` : ''}
                                        </Text>
                                    </Box>
                                </HStack>
                            )}
                        </Box>

                        {!confirmandoRemocaoDiv ? (
                            <Stack direction={{ base: 'column', sm: 'row' }} spacing={2} mt={3} flexWrap="wrap">
                                {correcaoDisponivel && divergenciaLocal.marcacoes?.photo && (
                                    <Button
                                        size={btnSize}
                                        colorScheme="purple"
                                        variant={fotoCorrigida ? 'outline' : 'solid'}
                                        leftIcon={<Icon as={FaCamera} />}
                                        onClick={() => setCorrigirImagemAberto(true)}
                                        w={{ base: '100%', sm: 'auto' }}
                                        {...wrapBtn}
                                    >
                                        {fotoCorrigida ? 'Corrigir imagem de novo' : 'Corrigir imagem do produto'}
                                    </Button>
                                )}
                                <Button
                                    size={btnSize}
                                    colorScheme="red"
                                    variant="outline"
                                    onClick={handleAbrirEdicaoDivergencia}
                                    w={{ base: '100%', sm: 'auto' }}
                                    {...wrapBtn}
                                >
                                    Editar
                                </Button>
                                <Button
                                    size={btnSize}
                                    colorScheme="red"
                                    variant="ghost"
                                    onClick={() => setConfirmandoRemocaoDiv(true)}
                                    w={{ base: '100%', sm: 'auto' }}
                                    {...wrapBtn}
                                >
                                    Remover
                                </Button>
                            </Stack>
                        ) : (
                            <Box bg="white" p={3} borderRadius="md" borderWidth="1px" borderColor="red.300" mt={3}>
                                <Text fontSize="sm" mb={2} color="red.700" fontWeight="semibold">
                                    Tem certeza que deseja remover esta divergência?
                                </Text>
                                <Stack direction={{ base: 'column', sm: 'row' }} spacing={2}>
                                    <Button
                                        size={btnSize}
                                        colorScheme="red"
                                        onClick={handleConfirmarRemocaoDivergencia}
                                        isLoading={removendoDivergencia}
                                        w={{ base: '100%', sm: 'auto' }}
                                        {...wrapBtn}
                                    >
                                        Confirmar Remoção
                                    </Button>
                                    <Button
                                        size={btnSize}
                                        variant="ghost"
                                        onClick={() => setConfirmandoRemocaoDiv(false)}
                                        isDisabled={removendoDivergencia}
                                        w={{ base: '100%', sm: 'auto' }}
                                        {...wrapBtn}
                                    >
                                        Cancelar
                                    </Button>
                                </Stack>
                            </Box>
                        )}
                    </Box>
                )}

                <Collapse in={showDivergenciaForm} animateOpacity>
                    <VStack px={4} pb={4} spacing={3} align="stretch">
                        {editandoDivergencia && (
                            <HStack justify="space-between">
                                <Text fontSize="sm" fontWeight="semibold" color="red.700">Editando divergência</Text>
                                <Button size="xs" variant="ghost" onClick={handleFecharFormDivergencia} isDisabled={salvandoDivergencia}>
                                    Cancelar
                                </Button>
                            </HStack>
                        )}
                        <Text fontSize="xs" color="red.700">
                            Selecione o(s) problema(s) identificado(s) no produto recebido.{!editandoDivergencia ? ' O produto será bloqueado automaticamente.' : ''}
                        </Text>

                        <SimpleGrid columns={{ base: 1, sm: 2 }} spacing={2}>
                            {[
                                { key: 'photo', label: 'Foto divergente' },
                                { key: 'name',  label: 'Nome divergente' },
                                { key: 'code',  label: 'Código divergente' },
                                { key: 'brand', label: 'Marca divergente' },
                                { key: 'avaria', label: 'Avaria / Dano' },
                            ].map(({ key, label }) => (
                                <Checkbox
                                    key={key}
                                    isChecked={divergenciaIssues[key]}
                                    onChange={(e) => setDivergenciaIssues(prev => ({ ...prev, [key]: e.target.checked }))}
                                    colorScheme="red"
                                    size="md"
                                >
                                    <Text fontSize="sm">{label}</Text>
                                </Checkbox>
                            ))}
                        </SimpleGrid>

                        <Textarea
                            placeholder="Observações sobre a divergência (opcional)..."
                            value={divergenciaObs}
                            onChange={(e) => setDivergenciaObs(e.target.value)}
                            bg="white"
                            size="sm"
                            rows={3}
                        />

                        {!editandoDivergencia && divergenciaIssues.photo && correcaoDisponivel && (
                            soFotoMarcada ? (
                                <>
                                    <Box bg="white" p={3} borderRadius="md" borderWidth="1px" borderColor="purple.200">
                                        <HStack spacing={2} align="start" mb={3}>
                                            <Icon as={FaCamera} color="purple.500" mt="3px" flexShrink={0} />
                                            <Box>
                                                <Text fontSize="sm" fontWeight="semibold" color="purple.800">Tem a peça em mãos?</Text>
                                                <Text fontSize="xs" color="gray.600">
                                                    Fotografe o item físico e publique como imagem oficial do produto. A divergência fica registrada como resolvida, sem bloquear o produto.
                                                </Text>
                                            </Box>
                                        </HStack>
                                        <Button
                                            colorScheme="purple"
                                            w="100%"
                                            size={btnSize}
                                            leftIcon={<Icon as={FaCamera} />}
                                            onClick={() => setCorrigirImagemAberto(true)}
                                            isDisabled={salvandoDivergencia}
                                            {...wrapBtn}
                                        >
                                            Corrigir imagem
                                        </Button>
                                    </Box>
                                    <HStack spacing={3} aria-hidden="true">
                                        <Divider borderColor="red.200" />
                                        <Text fontSize="xs" color="red.600" fontWeight="medium" flexShrink={0}>ou só bloquear</Text>
                                        <Divider borderColor="red.200" />
                                    </HStack>
                                </>
                            ) : (
                                <HStack spacing={2} align="start" bg="white" p={3} borderRadius="md" borderWidth="1px" borderColor="purple.200">
                                    <Icon as={FaCamera} color="purple.400" mt="3px" flexShrink={0} />
                                    <Text fontSize="xs" color="gray.600">
                                        Com outras divergências marcadas, registre primeiro. Depois dá para corrigir a imagem pelo card da divergência.
                                    </Text>
                                </HStack>
                            )
                        )}

                        <Button
                            colorScheme="red"
                            w="100%"
                            size={btnSize}
                            leftIcon={<Icon as={FaExclamationTriangle} />}
                            onClick={handleSalvarDivergencia}
                            isLoading={salvandoDivergencia}
                            isDisabled={!Object.values(divergenciaIssues).some(Boolean)}
                            {...wrapBtn}
                        >
                            {editandoDivergencia ? 'Salvar Alterações' : 'Confirmar — Bloquear Produto e Registrar Divergência'}
                        </Button>
                    </VStack>
                </Collapse>
            </Box>

            {!isManual && (
            <Box bg="white" p={4} borderRadius="lg" borderWidth="1px" borderColor="gray.200">
                <HStack justify="space-between" mb={3} flexWrap="wrap">
                    <HStack>
                        <Icon as={FaCheckCircle} color="orange.500" />
                        <Heading size="sm">Revisão no Mercado Livre</Heading>
                    </HStack>
                    <HStack spacing={2}>
                        {reviewBadge && <Badge colorScheme={reviewBadge.color}>{reviewBadge.label}</Badge>}
                        {devolucao.chegou_como_esperado === 1 && (
                            <Badge colorScheme="green" variant="subtle">Chegou como esperado</Badge>
                        )}
                        {devolucao.chegou_como_esperado === 0 && (
                            <Badge colorScheme="red" variant="subtle">Chegou com problema</Badge>
                        )}
                    </HStack>
                </HStack>

                {devolucao.type === 'not_delivered' ? (
                    <Alert status="info" borderRadius="md" variant="subtle">
                        <AlertIcon />
                        <Text fontSize="xs">
                            Esta devolução é do tipo <b>Não Entregue ao comprador</b> e não possui fluxo de revisão no Mercado Livre.
                            As ações de revisão estão desativadas.
                        </Text>
                    </Alert>
                ) : (
                    <>
                        {(() => {
                            const preAn = devolucao.pre_analise || '';
                            const marker = '=== ANÁLISE AUTOMÁTICA DE DEFEITOS ===';
                            const hasIa = preAn.includes(marker);
                            if (!hasIa) return null;
                            const idx = preAn.indexOf(marker);
                            const endMarker = '======================================';
                            const endIdx = preAn.indexOf(endMarker, idx + marker.length);
                            const bloco = endIdx > -1
                                ? preAn.substring(idx + marker.length, endIdx).trim()
                                : preAn.substring(idx + marker.length).trim();
                            return (
                                <Box
                                    bg="teal.50"
                                    borderWidth="1px"
                                    borderColor="teal.200"
                                    borderLeftWidth="4px"
                                    borderLeftColor="teal.500"
                                    borderRadius="md"
                                    p={3}
                                    mb={3}
                                >
                                    <HStack mb={2}>
                                        <Icon as={FaRobot} color="teal.600" />
                                        <Heading size="xs" color="teal.800">Análise automática (IA)</Heading>
                                        <Badge colorScheme="teal" fontSize="10px">GLM-4.5V</Badge>
                                    </HStack>
                                    <Text
                                        fontSize="xs"
                                        color="gray.700"
                                        whiteSpace="pre-wrap"
                                        fontFamily="mono"
                                        lineHeight="1.5"
                                    >
                                        {bloco}
                                    </Text>
                                </Box>
                            );
                        })()}
                        <Text fontSize="xs" color="gray.600" mb={3}>
                            Estas ações são enviadas diretamente ao Mercado Livre e afetam o status da devolução no painel ML.
                        </Text>

                        {qtdAnexadas === 0 && !jaRevisada && (
                            <Alert status="warning" borderRadius="md" py={2} fontSize="xs" mb={3}>
                                <AlertIcon boxSize={3} />
                                Anexe ao menos 1 foto da conferência antes de enviar a revisão ao ML.
                            </Alert>
                        )}
                        <SimpleGrid columns={{ base: 1, md: 3 }} spacing={3}>
                            <Tooltip label={jaRevisada ? 'Esta devolução já foi revisada no Mercado Livre. Ação bloqueada pois o ML não permite repetir.' : qtdAnexadas === 0 ? 'Anexe ao menos 1 foto antes de revisar.' : ''} hasArrow isDisabled={jaRevisada || qtdAnexadas > 0}>
                                <Button
                                    size={btnSize}
                                    colorScheme="green"
                                    leftIcon={<FaThumbsUp />}
                                    onClick={handleRevisaoOkClick}
                                    isDisabled={isLoading || !devolucao.id_ml || jaRevisada || qtdAnexadas === 0}
                                    isLoading={isLoading}
                                    {...wrapBtn}
                                >
                                    Chegou OK
                                </Button>
                            </Tooltip>
                            <Tooltip label={jaRevisada ? 'Esta devolução já foi revisada no Mercado Livre. Ação bloqueada pois o ML não permite repetir.' : qtdAnexadas === 0 ? 'Anexe ao menos 1 foto antes de revisar.' : ''} hasArrow isDisabled={jaRevisada || qtdAnexadas > 0}>
                                <Button
                                    size={btnSize}
                                    colorScheme="red"
                                    leftIcon={<FaThumbsDown />}
                                    variant={showRevisaoFalhaForm ? 'outline' : 'solid'}
                                    onClick={handleAbrirRevisaoFalha}
                                    isDisabled={isLoading || !devolucao.id_ml || jaRevisada || qtdAnexadas === 0}
                                    {...wrapBtn}
                                >
                                    Revisão com Falha
                                </Button>
                            </Tooltip>
                            <Button
                                size={btnSize}
                                colorScheme={pagoPor?.color === 'red' ? 'red' : 'blue'}
                                variant="outline"
                                leftIcon={<FaTruck />}
                                onClick={handleConsultarCustoClick}
                                isDisabled={isLoading || !devolucao.claim_id}
                                {...wrapBtn}
                            >
                                {shippingCostValor != null
                                    ? `Custo envio: ${formatBRL(shippingCostValor)}`
                                    : 'Consultar custo envio'}
                            </Button>
                        </SimpleGrid>

                        {shippingCostValor != null && pagoPor && (
                            <Alert status={pagoPor.status} borderRadius="md" mt={3} variant={pagoPor.color === 'red' ? 'solid' : 'subtle'}>
                                <AlertIcon />
                                <Box flex={1}>
                                    <HStack spacing={2} align="center" wrap="wrap">
                                        <Icon as={pagoPor.color === 'red' ? FaStore : FaTruck} />
                                        <Text fontWeight="bold" fontSize="sm">
                                            Custo do envio: {formatBRL(shippingCostValor)} — {pagoPor.label}
                                        </Text>
                                    </HStack>
                                    {pagoPor.detalhe && (
                                        <Text fontSize="xs" mt={1} opacity={0.95}>{pagoPor.detalhe}</Text>
                                    )}
                                </Box>
                            </Alert>
                        )}
                    </>
                )}

                <Collapse in={showRevisaoFalhaForm} animateOpacity>
                    <VStack align="stretch" spacing={3} mt={4} p={3} bg="red.50" borderRadius="md" borderWidth="1px" borderColor="red.200">
                        <FormControl isRequired>
                            <FormLabel fontSize="sm">Razão</FormLabel>
                            <Select
                                placeholder="Selecione a razão"
                                value={razaoRevisao}
                                onChange={(e) => setRazaoRevisao(e.target.value)}
                                bg="white"
                                size="sm"
                                isDisabled={isLoading}
                            >
                                {razoes.length === 0 ? (
                                    <option disabled value="">Carregando razões...</option>
                                ) : razoes.map(r => (
                                    <option key={r.code} value={r.code}>{r.code} - {r.label}</option>
                                ))}
                            </Select>
                        </FormControl>
                        <FormControl isRequired>
                            <FormLabel fontSize="sm">Descrição do problema</FormLabel>
                            <Textarea
                                placeholder="Descreva o problema em detalhes..."
                                value={mensagemRevisao}
                                onChange={(e) => setMensagemRevisao(e.target.value)}
                                bg="white"
                                size="sm"
                                maxLength={500}
                                isDisabled={isLoading}
                            />
                            <Text fontSize="xs" color="gray.500" mt={1}>{mensagemRevisao.length}/500</Text>
                        </FormControl>

                        <FormControl isRequired={requiresAttachments}>
                            <FormLabel fontSize="sm">
                                Evidências {requiresAttachments ? '(obrigatório para esta razão)' : '(opcional)'}
                            </FormLabel>

                            {Array.isArray(devolucao.arquivos_anexados) && devolucao.arquivos_anexados.length > 0 && (
                                <Box mb={2} p={2} bg="white" borderRadius="md" borderWidth="1px" borderColor="gray.200">
                                    <Text fontSize="xs" color="gray.600" mb={2} fontWeight="medium">
                                        Arquivos já anexados na devolução:
                                    </Text>
                                    <SimpleGrid columns={{ base: 2, md: 3 }} spacing={2}>
                                        {devolucao.arquivos_anexados.map((path) => {
                                            const nome = path.split('/').pop();
                                            const jaEnviado = attachmentsSelecionados.some(a => a.origem === path);
                                            const url = urlArquivo(path);
                                            const img = isImagem(nome);
                                            return (
                                                <Box
                                                    key={path}
                                                    p={1.5}
                                                    borderRadius="md"
                                                    borderWidth="1px"
                                                    borderColor={jaEnviado ? 'green.300' : 'gray.200'}
                                                    bg={jaEnviado ? 'green.50' : 'gray.50'}
                                                >
                                                    <Box
                                                        position="relative"
                                                        borderRadius="sm"
                                                        overflow="hidden"
                                                        cursor={img ? 'zoom-in' : 'default'}
                                                        onClick={() => img && abrirPreview(url, nome)}
                                                        bg="white"
                                                        h="70px"
                                                    >
                                                        {img ? (
                                                            <>
                                                                <Image src={url} alt={nome} w="100%" h="100%" objectFit="cover" />
                                                                <Box
                                                                    position="absolute"
                                                                    top={1}
                                                                    right={1}
                                                                    bg="blackAlpha.600"
                                                                    color="white"
                                                                    p={1}
                                                                    borderRadius="sm"
                                                                    fontSize="9px"
                                                                    display="inline-flex"
                                                                    alignItems="center"
                                                                    gap="2px"
                                                                >
                                                                    <Icon as={FaSearchPlus} boxSize="8px" />
                                                                </Box>
                                                            </>
                                                        ) : (
                                                            <VStack justify="center" h="100%" spacing={1}>
                                                                <Icon as={FaFileImage} color="gray.400" boxSize={5} />
                                                                <Text fontSize="9px" color="gray.500">Arquivo</Text>
                                                            </VStack>
                                                        )}
                                                    </Box>
                                                    <Tooltip label={nome} hasArrow>
                                                        <Text fontSize="10px" noOfLines={1} mt={1} color="gray.700">{nome}</Text>
                                                    </Tooltip>
                                                    <Button
                                                        size="xs"
                                                        mt={1}
                                                        w="100%"
                                                        variant={jaEnviado ? 'outline' : 'solid'}
                                                        colorScheme={jaEnviado ? 'green' : 'blue'}
                                                        onClick={(e) => { e.stopPropagation(); if (!jaEnviado) handleReuploadExistente(path); }}
                                                        isDisabled={uploadingAttachment || jaEnviado}
                                                    >
                                                        {jaEnviado ? '✓ Anexado' : 'Usar este'}
                                                    </Button>
                                                </Box>
                                            );
                                        })}
                                    </SimpleGrid>
                                </Box>
                            )}

                            <HStack>
                                <Button
                                    as="label"
                                    size="xs"
                                    colorScheme="blue"
                                    variant="outline"
                                    cursor="pointer"
                                    isDisabled={uploadingAttachment}
                                >
                                    {uploadingAttachment ? 'Enviando...' : '+ Upload novo arquivo'}
                                    <input
                                        type="file"
                                        hidden
                                        accept="image/*,application/pdf"
                                        onChange={handleUploadNovoAttachment}
                                    />
                                </Button>
                                <Text fontSize="10px" color="gray.500">
                                    JPG, PNG, WEBP, GIF ou PDF · máx 10MB
                                </Text>
                            </HStack>

                            {attachmentsSelecionados.length > 0 && (
                                <Box mt={2} p={2} bg="green.50" borderRadius="md" borderWidth="1px" borderColor="green.200">
                                    <Text fontSize="xs" color="green.800" mb={1} fontWeight="medium">
                                        {attachmentsSelecionados.length} evidência(s) que serão enviadas ao ML:
                                    </Text>
                                    <VStack align="stretch" spacing={1}>
                                        {attachmentsSelecionados.map((a) => (
                                            <HStack key={a.file_name} justify="space-between" fontSize="xs">
                                                <Text noOfLines={1}>{a.label}</Text>
                                                <Button
                                                    size="xs"
                                                    variant="ghost"
                                                    colorScheme="red"
                                                    onClick={() => removerAttachmentSelecionado(a.file_name)}
                                                >
                                                    Remover
                                                </Button>
                                            </HStack>
                                        ))}
                                    </VStack>
                                </Box>
                            )}
                        </FormControl>

                        <Button
                            size={btnSize}
                            colorScheme="red"
                            onClick={handleEnviarRevisaoFalha}
                            isLoading={isLoading}
                            isDisabled={
                                isLoading
                                || !razaoRevisao
                                || mensagemRevisao.trim().length < 5
                                || (requiresAttachments && attachmentsSelecionados.length === 0)
                            }
                            {...wrapBtn}
                        >
                            Enviar Revisão com Falha ao ML
                        </Button>
                    </VStack>
                </Collapse>
            </Box>
            )}

            <Tabs variant="enclosed-colored" colorScheme="orange" isFitted={{ base: true, md: false }}>
                <TabList overflowX="auto" overflowY="hidden">
                    <Tab>Itens</Tab>
                    <Tab>Detalhes</Tab>
                    <Tab>Cliente</Tab>
                    <Tab>Análise</Tab>
                </TabList>
                <TabPanels bg="white" border="1px solid" borderColor="inherit" borderTopWidth="0" borderRadius="0 0 0.375rem 0.375rem" p={{ base: 2, md: 4 }}>
                    
                    <TabPanel>
                        <VStack spacing={4} align="stretch">
                            {devolucao.orders && devolucao.orders.map((item, index) => (
                                <ItemRow item={item} key={item.item_id || index} />
                            ))}
                        </VStack>
                    </TabPanel>

                    <TabPanel>
                        <InfoRow label="Motivo da Devolução (Problema)">
                            <Text fontSize="sm" color="red.600" fontWeight="bold">
                                {adicional.problem || 'Motivo não especificado'}
                            </Text>
                        </InfoRow>

                        {adicional.resolution && typeof adicional.resolution === 'string' && (
                            <Box bg="blue.50" borderWidth="1px" borderColor="blue.200" borderRadius="md" p={3} mt={3}>
                                <Text fontSize="xs" color="blue.700" fontWeight="bold" textTransform="uppercase" mb={2}>
                                    Resolução
                                </Text>
                                <Text fontSize="sm" color="gray.800">{adicional.resolution}</Text>
                            </Box>
                        )}

                        {adicional.resolution && typeof adicional.resolution === 'object' && (
                            <Box bg="blue.50" borderWidth="1px" borderColor="blue.200" borderRadius="md" p={3} mt={3}>
                                <Text fontSize="xs" color="blue.700" fontWeight="bold" textTransform="uppercase" mb={2}>
                                    Resolução da Reclamação
                                </Text>
                                <SimpleGrid columns={{ base: 2, md: 4 }} spacing={3}>
                                    <InfoRow label="Beneficiado">
                                        <Text fontSize="sm" fontWeight="bold" color={
                                            adicional.resolution.benefited?.includes('respondent') ? 'green.600' : 'red.600'
                                        }>
                                            {adicional.resolution.benefited?.map(b =>
                                                b === 'complainant' ? 'Comprador' : b === 'respondent' ? 'Vendedor' : b
                                            ).join(', ') || 'N/A'}
                                        </Text>
                                    </InfoRow>
                                    <InfoRow label="Encerrado por">
                                        <Text fontSize="sm" fontWeight="medium" color="gray.700">
                                            {{ mediator: 'Mercado Livre', seller: 'Vendedor', buyer: 'Comprador' }[adicional.resolution.closed_by] || adicional.resolution.closed_by || 'N/A'}
                                        </Text>
                                    </InfoRow>
                                    <InfoRow label="Motivo Resolução">
                                        <Text fontSize="sm" fontWeight="medium" color="gray.700">
                                            {adicional.resolution.reason || 'N/A'}
                                        </Text>
                                    </InfoRow>
                                </SimpleGrid>
                            </Box>
                        )}

                        <Box bg="gray.50" borderWidth="1px" borderColor="gray.200" borderRadius="md" p={3} mt={4} mb={4}>
                            <SimpleGrid columns={{ base: 1, md: 3 }} spacing={3}>
                                {(() => {
                                    const ids = [
                                        { show: !!devolucao.id_venda,     icon: FaIdCard,     label: 'ID TAGA',         value: devolucao.id_venda,     display: `#${devolucao.id_venda}` },
                                        { show: !!devolucao.id_order_ml,  icon: FaBoxOpen,    label: 'ID ORIGEM (ML)',  value: devolucao.id_order_ml,  display: devolucao.id_order_ml },
                                        { show: !!devolucao.pack_id_ml,   icon: FaLayerGroup, label: 'ID PACK',         value: devolucao.pack_id_ml,   display: devolucao.pack_id_ml },
                                    ];
                                    return ids.filter(x => x.show).map(x => (
                                        <Tooltip key={x.label} label={`${x.label}: ${x.value} · clique para copiar`} hasArrow>
                                            <HStack
                                                align="flex-start"
                                                spacing={2}
                                                p={1}
                                                borderRadius="sm"
                                                cursor="pointer"
                                                _hover={{ bg: 'orange.50' }}
                                                onClick={() => copiarId(x.value, x.label)}
                                            >
                                                <Icon as={x.icon} color="gray.400" boxSize={3} mt={1} />
                                                <Box minW={0}>
                                                    <Text fontSize="10px" color="gray.500" fontWeight="bold" textTransform="uppercase">{x.label}</Text>
                                                    <Text fontSize="sm" fontFamily="mono" fontWeight="bold" color="gray.800" wordBreak="break-all">
                                                        {x.display}
                                                    </Text>
                                                </Box>
                                            </HStack>
                                        </Tooltip>
                                    ));
                                })()}
                            </SimpleGrid>
                        </Box>

                        <Divider my={4} />
                        <SimpleGrid columns={{ base: 2, md: 3 }} spacingX={6} spacingY={4}>
                            <InfoRow label="Data Limite Revisão" value={formatDateTime(adicional.due_date)} />
                            <InfoRow label="Data Prev. Entrega" value={formatDate(devolucao.estimated_delivery_time)} />
                            <InfoRow label="Data de Criação" value={formatDateTime(devolucao.date_created)} />

                            <InfoRow label="ID Devolução (ML)" value={devolucao.id_ml} />
                            <InfoRow label="ID Reclamação" value={devolucao.claim_id} />
                            <InfoRow label="Tipo" value={getTipoDevolucaoLabel(devolucao.type)} />
                            <InfoRow label="Subtipo" value={devolucao.subtype || 'N/A'} />

                            <InfoRow label="Status Devolução">
                                <Tag colorScheme={getStatusDevolucaoColor(devolucao.status)}>
                                    {getStatusDevolucaoLabel(devolucao.status)}
                                </Tag>
                            </InfoRow>
                            <InfoRow label="Status do Dinheiro">
                                <Tag colorScheme={getStatusMoneyColor(devolucao.status_money)}>
                                    {getStatusMoneyLabel(devolucao.status_money)}
                                </Tag>
                            </InfoRow>
                            <InfoRow
                                label="Revisão Vendedor"
                                value={
                                    sellerReview.reviews?.length > 0
                                        ? 'Revisado'
                                        : (sellerReview.status ? sellerReview.status : 'Nenhuma revisão')
                                }
                            />
                        </SimpleGrid>
                    </TabPanel>

                    <TabPanel>
                        <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4}>
                            <InfoRow label="Nome" value={`${cliente.first_name || ''} ${cliente.last_name || ''}`} />
                            <InfoRow label="Documento" value={`${cliente.doc_type || ''}: ${cliente.doc_number || ''}`} />
                            <GridItem colSpan={{ base: 1, md: 2 }}>
                                <InfoRow label="Endereço" value={formatAddress(cliente)} />
                            </GridItem>
                        </SimpleGrid>
                    </TabPanel>

                    <TabPanel>
                        <Grid templateColumns={{ base: "1fr", md: "1fr 1fr" }} gap={6}>
                            <VStack align="stretch" spacing={4}>
                                <Box>
                                    <Heading size="sm" mb={3}>Pré-análise (Opcional)</Heading>
                                    <Textarea 
                                        placeholder="Digite uma observação interna..."
                                        value={preAnalise}
                                        onChange={(e) => setPreAnalise(e.target.value)}
                                        mb={2}
                                        isDisabled={isLoading}
                                    />
                                </Box>
                                <Box>
                                    <Heading size="sm" mb={3}>Anexar Novos Arquivos</Heading>
                                    <FormControl>
                                        <Input 
                                            type="file" 
                                            multiple
                                            size="sm" 
                                            onChange={handleFileChange} 
                                            p={1}
                                            display="none"
                                            id="file-upload-input"
                                            isDisabled={isLoading}
                                        />
                                        <Button as="label" htmlFor="file-upload-input" colorScheme="blue" variant="outline" w="100%" isDisabled={isLoading}>
                                            Selecionar arquivos...
                                        </Button>
                                    </FormControl>
                                    
                                    {files.length > 0 && (
                                        <VStack align="stretch" spacing={2} mt={3} maxH="150px" overflowY="auto">
                                            {files.map((file, index) => (
                                                <HStack key={index} justify="space-between" p={2} bg="gray.100" borderRadius="md">
                                                    <HStack spacing={2} overflow="hidden">
                                                        <Icon as={FaFileImage} color="gray.500" />
                                                        <Tooltip label={file.name}>
                                                            <Text fontSize="sm" isTruncated>{file.name}</Text>
                                                        </Tooltip>
                                                    </HStack>
                                                    <IconButton 
                                                        icon={<FaTimes />} 
                                                        size="xs" 
                                                        variant="ghost"
                                                        colorScheme="red"
                                                        onClick={() => handleRemoveFile(file.name)} 
                                                        isDisabled={isLoading}
                                                    />
                                                </HStack>
                                            ))}
                                        </VStack>
                                    )}
                                </Box>
                                <Button
                                    colorScheme="blue"
                                    size="md"
                                    mt={3}
                                    onClick={handleAnexarESalvar}
                                    isLoading={isLoading}
                                    w="100%"
                                    {...wrapBtn}
                                >
                                    Salvar Análise e Anexos {files.length > 0 ? `(${files.length})` : ''}
                                </Button>
                            </VStack>
                            <VStack align="stretch" spacing={4}>
                                <Box>
                                    <Heading size="sm" mb={3}>Arquivos Anexados</Heading>
                                    {(!devolucao.arquivos_anexados || devolucao.arquivos_anexados.length === 0) ? (
                                        <Text fontSize="sm" color="gray.500">Nenhum arquivo anexado.</Text>
                                    ) : (
                                        <SimpleGrid columns={{ base: 2, md: 3 }} spacing={4}>
                                            {devolucao.arquivos_anexados.map((arqString, index) => {
                                                const filename = arqString.split('/').pop();
                                                const isImg = filename && /\.(jpe?g|png|gif|webp)$/i.test(filename);
                                                const url = `https://adm.tagaautopartes.com.br/${arqString}`;

                                                return (
                                                    <Box
                                                        key={index}
                                                        position="relative"
                                                        borderWidth="1px"
                                                        borderRadius="md"
                                                        p={2}
                                                        _hover={{ bg: "gray.100", boxShadow: "md" }}
                                                        h="100%"
                                                        transition="all 0.2s"
                                                    >
                                                        <IconButton
                                                            icon={<FaTrash />}
                                                            size="xs"
                                                            colorScheme="red"
                                                            position="absolute"
                                                            top="4px"
                                                            right="4px"
                                                            aria-label="Remover arquivo"
                                                            onClick={(e) => { e.stopPropagation(); e.preventDefault(); setArquivoParaRemover(arqString); }}
                                                            borderRadius="full"
                                                            boxShadow="md"
                                                            opacity={0.95}
                                                            zIndex={2}
                                                        />
                                                        <Link href={url} isExternal _hover={{textDecoration: 'none'}}>
                                                            {isImg ? (
                                                                <Image src={url} alt={filename} boxSize="100px" objectFit="cover" borderRadius="md" mx="auto" />
                                                            ) : (
                                                                <VStack justify="center" h="100px">
                                                                    <Icon as={FaFileImage} w={8} h={8} color="gray.400" />
                                                                </VStack>
                                                            )}
                                                            <Text fontSize="xs" color="gray.700" noOfLines={2} mt={2} textAlign="center" wordBreak="break-word" fontWeight="medium">
                                                                {filename || `Arquivo ${index + 1}`} <Icon as={FaExternalLinkAlt} mx="1px" fontSize="10px" />
                                                            </Text>
                                                        </Link>
                                                    </Box>
                                                );
                                            })}
                                        </SimpleGrid>
                                    )}
                                </Box>
                            </VStack>
                        </Grid>
                    </TabPanel>
                </TabPanels>
            </Tabs>

            <AlertDialog
                isOpen={!!arquivoParaRemover}
                leastDestructiveRef={cancelRemoveRef}
                onClose={() => !removendoArquivo && setArquivoParaRemover(null)}
                isCentered
            >
                <AlertDialogOverlay>
                    <AlertDialogContent mx={4}>
                        <AlertDialogHeader fontSize="lg" fontWeight="bold">
                            Remover arquivo?
                        </AlertDialogHeader>
                        <AlertDialogBody>
                            Esta ação é permanente e removerá o arquivo do servidor.
                        </AlertDialogBody>
                        <AlertDialogFooter>
                            <Button ref={cancelRemoveRef} onClick={() => setArquivoParaRemover(null)} isDisabled={removendoArquivo}>
                                Cancelar
                            </Button>
                            <Button colorScheme="red" onClick={confirmarRemocaoArquivo} ml={3} isLoading={removendoArquivo}>
                                Remover
                            </Button>
                        </AlertDialogFooter>
                    </AlertDialogContent>
                </AlertDialogOverlay>
            </AlertDialog>

            <Modal isOpen={isPreviewOpen} onClose={onPreviewClose} size="4xl" isCentered>
                <ModalOverlay bg="blackAlpha.800" />
                <ModalContent bg="transparent" boxShadow="none">
                    <ModalCloseButton color="white" bg="blackAlpha.600" _hover={{ bg: 'blackAlpha.800' }} />
                    <ModalBody display="flex" alignItems="center" justifyContent="center" p={0}>
                        {previewImagem && (
                            <VStack spacing={2}>
                                <Image
                                    src={previewImagem.url}
                                    alt={previewImagem.nome}
                                    maxH="85vh"
                                    maxW="100%"
                                    objectFit="contain"
                                    borderRadius="md"
                                />
                                <HStack spacing={2}>
                                    <Text color="white" fontSize="sm">{previewImagem.nome}</Text>
                                    <Link href={previewImagem.url} isExternal color="orange.300" fontSize="sm">
                                        <HStack spacing={1}>
                                            <Icon as={FaExpand} boxSize="10px" />
                                            <Text>Abrir em nova aba</Text>
                                        </HStack>
                                    </Link>
                                </HStack>
                            </VStack>
                        )}
                    </ModalBody>
                </ModalContent>
            </Modal>

            <ReembolsoMercadoPagoModal
                isOpen={isReembolsoMpOpen}
                onClose={() => setIsReembolsoMpOpen(false)}
                registroId={devolucao.id}
                onSuccess={() => onReembolsoConcluido && onReembolsoConcluido(devolucao.id)}
            />

            {correcaoDisponivel && (
                <CorrigirImagemModal
                    isOpen={corrigirImagemAberto}
                    onClose={() => setCorrigirImagemAberto(false)}
                    product={produtoCorrecao}
                    userId={usuarioLogado?.id}
                    onConfirmed={handleImagemCorrigida}
                />
            )}
        </VStack>
    );
};

export default KanbanFullDetails;